import { createFileRoute } from "@tanstack/react-router"

import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/roles-permissions/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { allowPrivateSpace: false })
  },
  head: () => ({
    meta: [
      {
        title: "Roles & Permissions | Arduino Cloud"
      }
    ]
  })
})
